// extracted by mini-css-extract-plugin
module.exports = {"container":"default_container__rfi1_","wrapper":"default_wrapper__QMuft","form":"default_form__9a_Ee","copy":"default_copy__uPKHi"};